module.exports = __webpack_public_path__ + "img/can-save-and-load_2022-01-11.png";